import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class UniversiteService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification/liste-universite'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  getUniversites = async () => {
  const response = await axios.get(`${this.API_URL}`);
  return response.data;
};

}